module.exports = __webpack_public_path__ + "static/media/asset.dc244ae3.png";